/** @jsx jsx */
import { css, jsx } from '@emotion/core'
import { ExternalStyles } from 'bold-ui'
import { ReactNode, useMemo } from 'react'

import { MCHAT_RF_RESULTADO_COLOR_SCALE_BY_TYPE, MChatRfResultadoType } from '../model-mChatRf'

interface MChatRfResultadoAlertProps {
  type: MChatRfResultadoType
  children: ReactNode
  style?: ExternalStyles
}

export function MChatRfResultadoAlert(props: Readonly<MChatRfResultadoAlertProps>) {
  const { type, children, style } = props

  const styles = useMemo(() => createStyles(type), [type])

  return <div css={[styles.alert, style]}>{children}</div>
}

const createStyles = (type: MChatRfResultadoType) => ({
  alert: css`
    color: ${MCHAT_RF_RESULTADO_COLOR_SCALE_BY_TYPE[type].c40};
    padding: 0.5rem 1rem;
    background-color: ${MCHAT_RF_RESULTADO_COLOR_SCALE_BY_TYPE[type].c90};
    border-left: 0.25rem solid ${MCHAT_RF_RESULTADO_COLOR_SCALE_BY_TYPE[type].c40};
  `,
})
